<template>
  <section class="section dark about-section grid grid-cols-2 sm-grid-cols-1 md-grid-cols-1">
    <div>
        <h3 v-if="showHeading" class="section-header">{{ heading }}</h3>
        <div v-html="htmlContent"></div>
    </div>
    <img src="../assets/mh.png" alt="Mediocre Hobbies Logo">
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { marked, Tokens } from 'marked';

export default defineComponent({
  name: 'AboutSection',
  props: {
    heading: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      required: true
    },
    showHeading: {
        type: Boolean,
        default: true
    }
  },
  data() {

    const renderer = {
      link({href, title, text}: Tokens.Link): string{
        const linkData = {
          href,
          title,
          text
        }
        return `<a href="${href}" target="_blank" rel="noreferrer">${text}</a>`;
      }
    };
    
    marked.use({
        renderer 
    });
    return {
        htmlContent: marked.parse(this.content),
    }
  }
});
</script>
